import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  InputGroup,
} from "reactstrap"
import Select from "react-select"
import makeAnimated from "react-select/animated"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/BreadcrumbBack"

//i18n
import { withTranslation } from "react-i18next"

//redux

import {
  getVariant as onGetVariant,
  productsResetError as onClearError,
  clearProduct as onClearProduct,
  addSeries as onSave,
} from "store/actions"
import { useDispatch, useSelector } from "react-redux"

//Custom CSS
import "./../custom.scss"
import moment from "moment"
import Swal from "sweetalert2"
import { Link } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"

import { isEmpty } from "lodash"
import Loading from "components/Common/Loading"

const SeriesCreate = props => {
  //meta title
  document.title = props.t("Create Serial Number")

  const [data, setData] = useState(null)

  const query = new URLSearchParams(props.location.search)
  const {
    match: { params },
  } = props

  const breadcrumbItems = [
    { title: props.t("Products"), link: "/v1/products" },
    { title: props.t("Variants"), link: `/v1/products/variants/${params.id}` },
    { title: props.t("Series No List"), link: `#` },
  ]

  const dispatch = useDispatch()
  const { error, variant, loading } = useSelector(state => ({
    error: state.Products?.error,
    loading: state.Products?.loading || false,
    variant: state.Products?.variant,
  }))

  useEffect(() => {
    if (isEmpty(variant) && !isEmpty(params.id)) {
      dispatch(onGetVariant(params.id))
    }
  }, [])
  useEffect(() => {
    if (!isEmpty(error)) {
      console.error("error", error)
      Swal.fire(
        props.t("Error"),
        error?.error ||
          error?.message ||
          error?.error?.message ||
          JSON.stringify(error),
        "error"
      ).then((isConfirmed)=>{
        if(isConfirmed){
          location.reload();
        }
      })
      dispatch(onClearError())
    }
  }, [error])

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      code: "",
      Product: query.get('pid'),
      Variant: params.id,
    },
    validationSchema: Yup.object({
      code: Yup.string().required(props.t("Required")),
      // className: Yup.string().required(props.t("Required")),
      // category: Yup.string().required(props.t("Required")),
      // subCategory: Yup.string().required(props.t("Required")),
    }),
    onSubmit: values => {
      console.log("values", values)
      //props.history.push(`/v1/products/create/step2/01`)

      dispatch(onSave(values, props.history))
    },
  })

  const insert = (arr, index, ...newItems) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index),
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${props.t("Serial Number")} (Barcode:${variant?.barcode})`}
            backLink={`/v1/products/variants/series/${params.id}?pid=${query.get("pid")}`}
            breadcrumbItems={breadcrumbItems}
          />
          <Loading status={loading} />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="card-title">{props.t("Create Series")}</h4>
                  <p className="card-title-desc">
                    {props.t("Create Series Description")}
                  </p>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom01">
                            {props.t("Serial No")}
                          </Label>
                          <Input
                            name="code"
                            placeholder={props.t("Serial No")}
                            type="text"
                            className="form-control"
                            id="validationCustom01"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.code || ""}
                            invalid={
                              validation.touched.code && validation.errors.code
                                ? true
                                : false
                            }
                          />
                          {validation.touched.code && validation.errors.code ? (
                            <FormFeedback type="invalid">
                              {validation.errors.code}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button color="primary" type="submit">
                      {props.t("Save")}
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

SeriesCreate.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(SeriesCreate)
